module.exports = __webpack_public_path__ + "img/b_Rentrit_right.bf4b5b17.jpeg";